var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09724 0.891606C9.09724 -0.297202 10.9033 -0.297202 10.9033 0.891606V11.5768L12.8098 9.67032C13.6503 8.82978 14.9273 10.1068 14.0867 10.9473L10.6388 14.3953C10.286 14.748 9.71421 14.748 9.36177 14.3953L5.91352 10.947C5.07298 10.1065 6.34996 8.82952 7.1905 9.67006L9.09724 11.5768V0.891606ZM18.1942 9.98859V16.8167C18.1942 17.566 17.5775 18.1827 16.8283 18.1827H3.17198C2.42249 18.1827 1.80604 17.566 1.80604 16.8167V9.98859C1.80604 8.79978 0 8.79978 0 9.98859V16.8167C0 18.5636 1.42568 19.9887 3.17198 19.9887H16.828C18.5748 19.9887 20 18.563 20 16.8167V9.98859C20.0003 8.79978 18.1942 8.79978 18.1942 9.98859Z",
    fill: "#5981e9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3dee201e1b0464607c17374b17878aa5.svg";
export { ForwardRef as ReactComponent };